import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import trading from '../assets/images/trading.jpg';
import trading1 from '../assets/images/blog-1.jpeg';
import { Link } from "react-router-dom";

const Blogs = () => {
  return (
    <div className="bg-white dark:bg-gray-900 text-gray-900 dark:text-white transition-colors duration-300">
      <Header />
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-10">
        <h1 className="text-3xl font-bold mb-6">Tillionx Blog</h1>

        <div className="mb-10">
          <input
            type="text"
            placeholder="Search Posts"
            className="w-full max-w-md border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-yellow-500"
          />
        </div>
            <Link to="/blogs-page">
        <div className="flex flex-col md:flex-row items-start md:items-center gap-6 mb-10">
          <div className="w-full md:w-1/3">
            <img
              src={trading}
              alt="Tillionx is SAFU"
              className="rounded-lg shadow-md W-[250px] h-[250px] object-cover mb-4 md:mb-0"
            />
          </div>

          <div className="flex-1">
            <span className="text-sm bg-gray-100 text-gray-600 px-3 py-1 rounded-md">
              Security
            </span>

            <h2 className="text-2xl font-bold mt-4 mb-2">
              Tillionx Is SAFU: Here’s How We Secure Your Assets 24/7
            </h2>

            <p className="text-gray-600 mb-3">
              Here’s how Tillionx protects your crypto with industry-leading
              security measures, real-time threat monitoring, and the SAFU fund.
            </p>

            <p className="text-sm text-gray-400">2025-02-25</p>

            
          </div>
        </div>
          </Link>
         <Link to="/blogs-page">
          <div className="flex flex-col md:flex-row items-start md:items-center gap-6 mb-10">
          <div className="w-full md:w-1/3">
            <img
              src={trading1}
              alt="Tillionx is SAFU"
              className="rounded-lg shadow-md W-[250px] h-[250px] object-cover mb-4 md:mb-0"
            />
          </div>

          <div className="flex-1">
            <span className="text-sm bg-gray-100 text-gray-600 px-3 py-1 rounded-md">
              Security
            </span>

            <h2 className="text-2xl font-bold mt-4 mb-2">
               Mark Price vs. Last Price on Tillionx Futures – What’s the Difference?
            </h2>

            <p className="text-gray-600 mb-3">
              Here’s how Tillionx protects your crypto with industry-leading
              security measures, real-time threat monitoring, and the SAFU fund.
            </p>

            <p className="text-sm text-gray-400">2025-02-25</p>

            
          </div>
        </div>
         </Link>
      </div>
      <Footer />
    </div>
  );
};

export default Blogs;
